<template>
  <div v-if="viewTypeTab === 'desktopViewTab'">
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>Message</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsTitleMessage :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="!isPromoTile">
        <v-expansion-panel-title>Size</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="promo-design-group">
            <v-text-field
              v-model.trim="actions.rf_settings_text_container_max_width"
              hideDetails
              variant="outlined"
              persistentPlaceholder
              density="compact"
              label="Message Width"
              name="fill_color"
              required
            ></v-text-field>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Background</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionImageUpload :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>User Interaction </v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <v-radio-group
            v-if="model.device_type === 'web' || app.flags.custom_devices || horizontalDevices"
            v-model="actions.rf_settings_tile_interaction"
            inline
            hideDetails
            class="inline-interactions-opt"
          >
            <v-radio v-if="!horizontalDevices" value="button" label="Buttons" />
            <v-radio value="container" label="Block" />
            <v-radio value="none" label="None" />
          </v-radio-group>
          <div
            v-if="
              actions.rf_settings_tile_interaction === 'none' &&
              (model.device_type === 'web' || app.flags.custom_devices || horizontalDevices)
            "
            class="promo-design-group interactions-opt-item"
          >
            <div>
              <v-checkbox
                v-model="actions.rf_settings_close_button_enabled"
                label="Allow close"
                trueValue="true"
                falseValue="false"
                class="promotion-closeBtn-checkbox"
              />
            </div>
            <div v-if="actions.rf_settings_close_button_enabled === 'true'">
              <div style="padding-bottom: 20px">
                <RfPromoInteractionInterval
                  interactionType="dismiss"
                  :action="actions.rf_settings_dismiss_interval"
                  @setIntervalAction="setIntervalAction"
                />
              </div>
              <RfRetentionActionsBehavior :model="model" :actions="actions" displayOff />
            </div>
            <span class="gray-text">Only dismiss and timeout actions are possible</span>
          </div>
          <div
            v-if="actions.rf_settings_tile_interaction === 'container'"
            class="promo-design-group interactions-opt-item"
          >
            <RfTileContainerOptions :model="model" :actions="actions" />
          </div>
          <RfPromoInteractionInterval
            v-if="!isSticky && actions.rf_settings_tile_interaction !== 'button'"
            interactionType="clickButton1"
            :action="actions.rf_settings_accept_interval"
            @setIntervalAction="setIntervalAction"
          />
          <div
            v-if="actions.rf_settings_tile_interaction === 'button'"
            class="promo-design-group interactions-opt-item"
          >
            <RfRetentionButtons
              :actions="actions"
              :model="model"
              :isCustomDevicesEnabled="app.flags.custom_devices"
              showCloseOptions
              @forceRender="$emit('forceRender')"
            />
            <RfRetentionButtonsAlignment
              :actions="actions"
              :model="model"
              @forceRender="$emit('forceRender')"
            />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web'">
        <v-expansion-panel-title>Form</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionFieldSet :model="model" :actions="actions" :requireAcceptButton="true" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web'">
        <v-expansion-panel-title>Consent Checkbox</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionConsent :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web'">
        <v-expansion-panel-title>Countdown Timer</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsCountdown :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="inApp">
        <v-expansion-panel-title>In-App Purchase</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsInapp :actions="actions" :app="app" :deviceType="model.device_type" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type !== 'web'">
        <v-expansion-panel-title>Deep Link</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsDeeplink :deviceType="model.device_type" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Device Metadata</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMetadata :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="promo-design-group">
            <RfPromoCustomCSS :actions="actions" />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web' && app.flags.paywalls">
        <v-expansion-panel-title>Paywall</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPaywallConfig :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-else>
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>CONFIGURATION</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMobileWeb :app="app" :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPromoCustomCSS :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import RfRetentionActionsTitleMessage from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsTitleMessage.vue";
import RfRetentionActionsDeeplink from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsDeeplink.vue";
import RfRetentionActionsMetadata from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMetadata.vue";
import RfRetentionActionsBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsBehavior.vue";
import RfRetentionButtons from "@/components/RfPathCreate/RfRetentionActions/RfRetentionButtons.vue";
import RfRetentionButtonsAlignment from "@/components/RfPathCreate/RfRetentionActions/RfRetentionButtonsAlignment.vue";
import RfRetentionActionsInapp from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsInapp.vue";
import RfRetentionActionsMobileWeb from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMobileWeb.vue";
import RfPromoCustomCSS from "@/components/RfPromotions/RfPromoCustomCSS.vue";
import RfTileContainerOptions from "@/components/RfPathCreate/RfRetentionActions/RfTileContainerOptions.vue";
import RfPromoInteractionInterval from "@/components/RfPromotions/RfPromoInteractionInterval.vue";
import RfRetentionImageUpload from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionImageUpload.vue";
import RfRetentionFieldSet from "@/components/RfPathCreate/RfRetentionActions/RfRetentionFieldSet.vue";
import RfRetentionConsent from "@/components/RfPathCreate/RfRetentionActions/RfRetentionConsent.vue";
import RfRetentionActionsCountdown from "./RfRetentionActionsCountdown.vue";
import RfPaywallConfig from "./RfPaywallConfig.vue";
import { hasInapp } from "@/utils/prompts/promptHelpers";
import { DefaultDeviceOptions } from "@/utils/constants/DevicesConstants";
import { PromptTypes } from "@/utils/constants/PromoTypesConstants";

export default {
  name: "RfRetentionActionsInlinePromo",
  components: {
    RfRetentionActionsTitleMessage,
    RfRetentionActionsDeeplink,
    RfRetentionActionsBehavior,
    RfRetentionButtons,
    RfRetentionButtonsAlignment,
    RfRetentionActionsInapp,
    RfRetentionActionsMobileWeb,
    RfPromoCustomCSS,
    RfTileContainerOptions,
    RfRetentionActionsMetadata,
    RfPromoInteractionInterval,
    RfRetentionImageUpload,
    RfRetentionFieldSet,
    RfRetentionConsent,
    RfRetentionActionsCountdown,
    RfPaywallConfig,
  },
  props: ["actions", "model", "app", "viewTypeTab"],
  data() {
    return {
      getPromoPanel: [0],
    };
  },
  computed: {
    inApp() {
      return hasInapp(this.model) || this.model.device_type === DefaultDeviceOptions.tv_os.value;
    },
    isPromoTile() {
      return (
        this.model.path_type === PromptTypes.tile.value ||
        this.model.path_type === PromptTypes.vertical.value
      );
    },
    horizontalDevices() {
      return [
        DefaultDeviceOptions.tv_os.value,
        DefaultDeviceOptions.android_os.value,
        DefaultDeviceOptions.android_tv.value,
        DefaultDeviceOptions.ios.value,
      ].includes(this.model.device_type);
    },
    isSticky() {
      return (
        this.actions.rf_settings_tile_interaction === "container" &&
        `${this.actions.rf_settings_permanent_display}` === "true"
      );
    },
  },
  watch: {},
  methods: {
    setIntervalAction(value, type) {
      this.actions[`rf_settings_${type}_interval`] = value;
    },
  },
};
</script>
